import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49daa55e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = {
  key: 0,
  class: "entity-highlight"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'cancel-trust-dialog',
  props: {
    modelValue: { type: Boolean },
    threatEntity: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const props = __props
const emit = __emit

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const confirmTextParts = computed(() => {
  const entity = props.threatEntity
  if (!entity) return { prefix: t('securityEvent.cancelTrustConfirm'), suffix: '' }

  const fullText = t('securityEvent.cancelTrustConfirm', { threat_entity: entity })
  const idx = fullText.indexOf(entity)
  if (idx >= 0) {
    return {
      prefix: fullText.substring(0, idx),
      suffix: fullText.substring(idx + entity.length),
    }
  }
  return { prefix: fullText, suffix: '' }
})

function onConfirm () {
  emit('confirm')
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: _ctx.$t('securityEvent.cancelTrustTitle'),
    width: "480px",
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createTextVNode(_toDisplayString(confirmTextParts.value.prefix), 1),
        (props.threatEntity && confirmTextParts.value.suffix)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.threatEntity), 1))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(confirmTextParts.value.suffix), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})